// ErrorContext.tsx
import React, { createContext, useState, useContext, ReactNode } from "react";
import ErrorNotification from "../components/ErrorNotification";

interface ErrorContextProps {
  showError: (message: string) => void;
}

const ErrorContext = createContext<ErrorContextProps | undefined>(undefined);

export const useError = (): ErrorContextProps => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within an ErrorProvider");
  }
  return context;
};

interface ErrorProviderProps {
  children: ReactNode;
}

export const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
  const [error, setError] = useState("");

  const showError = (message: string) => {
    setError(message);
  };

  return (
    <ErrorContext.Provider value={{ showError }}>
      <ErrorNotification message={error} onClose={() => setError("")} />
      {children}
    </ErrorContext.Provider>
  );
};
